const filesToAttachments = async (files: File[]): Promise<any[]> => {
	const attachments = await Promise.all(
		files.map((file) => {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = () => {
					const base64 = (reader.result as string).split(',')[1];
					resolve({
						filename: file.name,
						content: base64,
						encoding: 'base64',
						contentType: file.type,
					});
				};
				reader.onerror = reject;
				reader.readAsDataURL(file);
			});
		})
	);

	return attachments;
};

export default filesToAttachments;
